module.exports = __webpack_public_path__ + "img/super_video_face.9ddda614.png";